import { z } from "zod";

/** ກົດລະບຽບທີ່ໃຊ້ແມ່ນ package_template_allowed_rules.id (ຄືຕອນຂາຍ) */
export const UpdatePackageSelectedClassesSchema = z.object({
  selectedRuleIds: z.array(z.string().min(1)).min(1),
  classSessions: z
    .array(
      z.object({
        ruleId: z.string(),
        sessions: z.number().int().positive(),
      }),
    )
    .optional(),
  /** ຢືນຢັນໂອນຈຳນວນຄັ້ງທີ່ໃຊ້ແລ້ວໄປຄລາດໃໝ່ເມື່ອປ່ຽນກຸ່ມຄລາດ */
  transferUsedSessions: z.boolean().optional(),
});

export type UpdatePackageSelectedClassesDTO = z.infer<
  typeof UpdatePackageSelectedClassesSchema
>;
